import {
    FETCH_DELETE_USERS_REQUEST,
    FETCH_DELETE_USERS_SUCCESS,
    FETCH_DELETE_USERS_FAILURE,
} from '../../actions/users/delete-user-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteUserReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_USERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_USERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_USERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteUserReducer;